<template>
  <div>
    <div class="container">
      <h1 class="page-title text-center mt-5 d-none d-md-block">Xilda Network</h1>
      <h2 class="sub-title text-center mb-4 mb-md-5 d-none d-md-block">
        {{ $t("message.storelocator") }}
      </h2>
      <!--
      <form class="form-row align-items-md-end d-none d-md-flex" @submit.prevent="onSubmit">
        <div class="form-group col-lg-6">
          <label for="store-name">{{ $t('message.storename') }}</label>
          <input type="text" class="form-control" id="store-name" autocomplete="off" v-model="form.search" name="search" :placeholder="$t('message.storeexample')">
        </div>
        <div class="form-group col-md-7 col-lg-4">
          <label for="store-province">{{ $t('message.province') }}</label>
          <select class="form-control" id="store-province" name="id" v-model="form.province">
            <option value="">{{ $t('message.allprovinces') }}</option>
            <optgroup v-for="region in regions" :key="region.id" :label="region.name">
              <option v-for="pv in childrenOf(region.id)" :key="pv.id" :value="pv.id">{{ pv.name }}</option>
            </optgroup>
          </select>
        </div>
        <div class="form-group col-md-5 col-lg-2">
          <button class="btn dark w-100" type="submit">{{ $t('message.search') }}</button>
        </div>
      </form>
    -->
    <!--
      <div class="map-container" id="map-container" ref="map-container">
        <! -- <div class="map-option d-md-none">
          <div class="container py-2">
            <a href="#" class="btn btn-link" @click.prevent="toggleMap">{{ isShowMap ? 'View lists' : 'View map' }}</a>
            <span class="m-0 text-black-50">ผลการค้นหา {{ totalResults }} ร้าน</span>
          </div>
        </div> -- ß>
        <div class="map-panel" id="map-panel" ref="map-panel" :class="{ opened: isOpened, 'd-none d-md-block': isShowMap }">
          <div class="placeholder pr-4" v-if="!isDataLoaded">
            <div class="page-title mb-4"></div>
            <div class="paragraph" style="width: 75%;"></div>
            <div class="paragraph" style="width: 100%;"></div>
            <div class="paragraph" style="width: 80%;"></div>
            <div class="paragraph" style="width: 50%;"></div>
          </div>
          <template v-else>
            <div class="details-contain" :class="{'show-detail': isShowStoreDetail}">
              <div class="store-results">
                <h3>{{ $t('message.storeresults', { total: totalResults }) }}</h3>
                <ul class="store-lists">
                  <li v-for="item in mapMarkers" :key="item.location.id" @click="selectMark(item)" :class="activeClass(item.location.id)" :id="`store-${item.location.id}`">
                    <div class="d-flex align-items-start">
                      <div class="store-thumbnail" v-if="!!item.location._embedded['wp:featuredmedia']">
                        <div class="store-thumbnail-media" :style="{ backgroundImage: `url(${item.location._embedded['wp:featuredmedia'][0].media_details.sizes['post-thumbnail-md'].source_url})` }"></div>
                      </div>
                      <div class="store-content">
                        <h4>{{ item.location.title.rendered }}</h4>
                        <p v-if="item.location.acf.address">{{ item.location.acf.address }}</p>
                        <div class="d-none d-md-block">
                          <a class="btn dark small mr-2" role="button" target="_blank" @click.prevent="selectItem(item.location)" href="#">{{ $t('message.detail') }}</a>
                          <a class="btn light small" role="button" target="_blank" @click.prevent="openMap(item.location.acf.location)" :href="getMapUrl(item.location.acf.location)">{{ $t('message.direction') }}</a>
                        </div>
                      </div>
                    </div>
                    <div class="d-md-none">
                      <a class="btn dark small mr-2" role="button" target="_blank" @click.prevent="selectItem(item.location)" href="#">รายละเอียด</a>
                      <a class="btn light small" role="button" target="_blank" @click.prevent="openMap(item.location.acf.location)" :href="getMapUrl(item.location.acf.location)">เส้นทาง</a>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="store-detail">
                <template v-if="isShowStoreDetail">
                  <h3 class="d-flex align-items-center"><button type="button" class="btn-back mr-2" @click.prevent="isShowStoreDetail = false"><img :src="backIcon" :srcset="`${backIcon2X} 2x`" alt=""></button> {{ selectedItem.title.rendered }}</h3>
                  <img :src="selectedItem._embedded['wp:featuredmedia'][0].source_url" :alt="selectedItem._embedded['wp:featuredmedia'][0].alt_text" class="img-fluid d-block mb-3" v-if="!!selectedItem._embedded['wp:featuredmedia']">
                  <p v-if="selectedItem.acf.address">{{ selectedItem.acf.address }}</p>
                  <a class="btn light small mb-3" role="button" target="_blank" @click.prevent="openMap(selectedItem.acf.location)" :href="getMapUrl(selectedItem.acf.location)">{{ $t('message.direction') }}</a>
                  <div class="row mb-2" v-if="selectedItem.acf.barber_name">
                    <div class="col-4">{{ $t('message.barbername') }}</div>
                    <div class="col-8">{{ selectedItem.acf.barber_name }}</div>
                  </div>
                  <div class="row mb-2" v-if="selectedItem.acf.phone_number">
                    <div class="col-4">{{ $t('message.phonenumber') }}</div>
                    <div class="col-8"><a :href="`tel:${selectedItem.acf.phone_number}`">{{ selectedItem.acf.phone_number }}</a></div>
                  </div>
                  <template v-if="selectedItem.acf.sns">
                    <div class="row mb-2" v-for="(sns, key) in selectedItem.acf.sns" :key="key">
                      <div class="col-4 text-capitalize">{{ sns.social_network }}</div>
                      <div class="col-8">
                        <template v-if="sns.social_network_link">
                          <a :href="sns.social_network_link" target="_blank">{{ sns.social_network_username }}</a>
                        </template>
                        <template v-else>{{ sns.social_network_username }}</template>
                      </div>
                    </div>
                  </template>
                </template>
              </div>
            </div>
          </template>
        </div>
        <div id="map"></div>
      </div>
    -->
      <div class="all-stores mt-5">
        <h3 class="text-center">{{ $t('message.allstores') }}</h3>
        <div class="region-lists d-flex justify-content-md-center my-3 flex-nowrap">
          <button type="button" class="region-button" :class="{ active: selectedRegion === '' }" @click.prevent="selectedRegion = ''">{{ $t('message.all') }}</button>
          <button type="button" v-for="item in regions" :key="item.id" class="region-button text-nowrap" :class="{ active: selectedRegion === item.id }" @click.prevent="selectedRegion = item.id">{{ item.name }}</button>
        </div>
        <div class="store-row-header row">
          <div class="col-3"><strong>{{ $t('message.storename') }}</strong></div>
          <div class="col-2"><strong>{{ $t('message.phonenumber') }}</strong></div>
          <div class="col-5"><strong>{{ $t('message.address') }}</strong></div>
          <div class="col-2 text-center"><strong>{{ $t('message.direction') }}</strong></div>
        </div>
        <accordion :contents="filteredAllData" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import markerIcon from '../../assets/images/map-marker@2x.png'
import markerIconSelected from '../../assets/images/map-marker-selected@2x.png'
import backIcon from '../../assets/images/back.png'
import backIcon2X from '../../assets/images/back@2x.png'
export default {
  name: 'XildaNetwork',
  data () {
    return {
      api_path: process.env.VUE_APP_API_PATH,
      title: process.env.VUE_APP_TITLE,
      isDataLoaded: false,
      data: [],
      allData: [],
      map: null,
      mapCenter: { lat: 13.742732, lng: 100.6083957 },
      mapMarkers: [],
      isOpened: false,
      provinces: [],
      form: {
        search: '',
        province: ''
      },
      totalResults: 0,
      selectedStore: [],
      selectedItem: [],
      backIcon,
      backIcon2X,
      isShowStoreDetail: false,
      selectedRegion: '',
      isShowMap: false
    }
  },
  mounted () {
    document.title = `Xilda Network - ${this.title}`
    this.getData()
    this.getProvinces()
    window.checkAndAttachMapScript(this.initMap)
  },
  methods: {
    getData () {
      const $vm = this
      const lang = $vm.$route.params.lang
      $vm.isDataLoaded = false
      axios.get(`${$vm.api_path}wp-json/wp/v2/network`, {
        params: {
          _embed: true,
          per_page: 100,
          ...($vm.form.search ? { search: $vm.form.search } : {}),
          ...($vm.form.province ? { provinces: $vm.form.province } : {}),
          lang
        }
      })
        .then(res => {
          const locations = []
          $vm.data = res.data
          if (!$vm.allData.length) {
            $vm.data.forEach(item => {
              $vm.allData.push({ ...item, active: false })
            })
          }
          $vm.data.forEach(item => {
            if (item.acf.location) {
              const { lat, lng } = item.acf.location
              locations.push({
                lat,
                lng,
                ...item
              })
            }
          })
          $vm.setMarkers(locations)
          $vm.totalResults = parseInt(res.headers['x-wp-total'])
          $vm.isDataLoaded = true
        })
    },
    getProvinces () {
      const $vm = this
      const lang = $vm.$route.params.lang
      axios.get(`${$vm.api_path}wp-json/wp/v2/provinces`, {
        params: {
          per_page: 100,
          lang
        }
      })
        .then(res => {
          this.provinces = res.data
        })
    },
    initMap () {
      this.map = new window.google.maps.Map(document.getElementById('map'), {
        center: this.mapCenter,
        zoom: 6,
        fullscreenControl: false,
        scrollwheel: false
      })
    },
    setMarkers (locations) {
      const markers = []
      locations.forEach((location, key) => {
        const { lat, lng } = location
        const marker = new window.google.maps.Marker({
          position: {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
          },
          map: this.map,
          icon: markerIcon,
          location
        })

        window.google.maps.event.addListener(marker, 'click', ((marker, key) => {
          return () => {
            this.theClick(marker)
            const container = document.getElementsByClassName('store-results')
            const storeItem = document.getElementById(`store-${marker.location.id}`)
            console.log(storeItem.offsetTop)
            const position = storeItem.offsetTop
            console.log(position)
            container[0].scrollTop = position
          }
        })(marker, key))

        this.mapMarkers.push(marker)
        markers.push({
          lat: parseFloat(lat),
          lng: parseFloat(lng)
        })
      })
      const bounds = new window.google.maps.LatLngBounds()
      for (let i = 0; i < markers.length; i++) {
        bounds.extend(markers[i])
      }
      this.map.fitBounds(bounds)
    },
    theClick (marker) {
      this.selectedStore = marker
      this.isOpened = true
      this.map.setZoom(14)
      const mapWidth = this.$refs['map-container'].clientWidth
      const panelWidth = this.$refs['map-panel'].clientWidth
      const offsetX = ((mapWidth - panelWidth) / 2) / 2
      this.offsetCenter(marker.position, offsetX, 0)
      this.mapMarkers.forEach(m => {
        m.setIcon(markerIcon)
      })
      marker.setIcon(markerIconSelected)
    },
    offsetCenter (latLng, offsetX, offsetY) {
      const scale = Math.pow(2, this.map.getZoom())
      const worldCoordinateCenter = this.map.getProjection().fromLatLngToPoint(latLng)
      const pixelOffset = new window.google.maps.Point((offsetX / scale) || 0, (offsetY / scale) || 0)
      const worldCoordinateNewCenter = new window.google.maps.Point(
        worldCoordinateCenter.x - pixelOffset.x,
        worldCoordinateCenter.y - pixelOffset.y
      )
      const newCenter = this.map.getProjection().fromPointToLatLng(worldCoordinateNewCenter)
      this.map.setCenter(newCenter)
    },
    childrenOf (id) {
      return this.provinces.filter(g => g.parent === id)
    },
    clearMarkers () {
      for (var i = 0; i < this.mapMarkers.length; i++) {
        this.mapMarkers[i].setMap(null)
      }
      this.mapMarkers = []
    },
    onSubmit () {
      this.isShowStoreDetail = false
      this.selectedItem = []
      this.selectedStore = []
      this.clearMarkers()
      this.getData()
      this.isOpened = true
    },
    selectMark (item) {
      this.theClick(item)
    },
    openMap (location) {
      window.open(location, '_blank')
    },
    getMapUrl (location) {
      const { address, lat, lng } = location
      let destination
      if (address) {
        destination = address
      } else {
        destination = `${lat},${lng}`
      }
      return `https://www.google.com/maps/dir/?api=1&destination=${destination}`
    },
    activeClass (id) {
      if (this.selectedStore.location) {
        if (this.selectedStore.location.id === id) {
          return 'active'
        }
      }
      return null
    },
    selectItem (item) {
      this.selectedItem = item
      this.isShowStoreDetail = true
    },
    toggleMap () {
      this.isShowMap = !this.isShowMap
    }
  },
  computed: {
    regions () {
      return this.provinces.filter(g => !g.parent)
    },
    province () {
      return this.provinces.filter(g => g.parent)
    },
    filteredAllData () {
      if (this.selectedRegion) {
        return this.allData.filter(item => {
          return item.provinces.includes(this.selectedRegion)
        })
      } else {
        return this.allData
      }
    }
  }
}
</script>
